import React from 'react';
import { Sparkles } from 'lucide-react';

const PRACTICES = [
  { title: 'Be specific about constraints', description: "Vague RFPs attract vague proposals. State your budget range, timeline, and technical constraints upfront. You'll filter out 80% of unqualified vendors automatically.", stat: '80%', statLabel: 'fewer unqualified responses' },
  { title: 'Scoring criteria > Gut feel', description: "Define evaluation criteria before you see proposals. ProposAI's AI enforces this by scoring every submission against your rubric—eliminating recency bias and personal preferences.", stat: '3x', statLabel: 'better vendor fit' },
  { title: 'Ask for proof, not promises', description: "Request case studies, GitHub repos, or portfolio samples. Our AI automatically flags proposals lacking evidence and highlights vendors with proven track records.", stat: '65%', statLabel: 'higher success rate' },
  { title: 'Iterate based on feedback', description: "If you're getting bad proposals, your RFP might be the problem. ProposAI shows you which sections confuse vendors so you can refine and repost quickly.", stat: '2.4x', statLabel: 'faster iterations' },
];

export default function LandingPractices() {
  return (
    <section id="best-practices" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-green-50 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Sparkles className="w-4 h-4" />
            <span>Industry Insights</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">RFP best practices that actually work</h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {"We've analyzed thousands of successful RFPs. Here's what separates winners from time-wasters."}
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {PRACTICES.map((practice) => (
            <div key={practice.title} className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-slate-200 hover:shadow-lg transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <h3 className="text-2xl font-bold text-slate-900 flex-1">{practice.title}</h3>
                <div className="text-right ml-4">
                  <div className="text-3xl font-bold text-primary">{practice.stat}</div>
                  <div className="text-sm text-slate-500">{practice.statLabel}</div>
                </div>
              </div>
              <p className="text-slate-600 leading-relaxed">{practice.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
